export enum OfficeChargeUnitOfMeasure {
  PER_ACTUAL_KG = "per actual weight",
  PER_CHARGEABLE_KG = "per chargeable weight",
  PER_MAWB = "per MAWB",
  PER_HAWB = "per HAWB",
  PER_SHIPMENT = "per shipment",
}
